import { useSelector } from 'react-redux';
import { leadNamesSelector } from '../../ecg/selectors/signal.selectors';
import { AxisContainer } from './AxisContainer';
import { DefaultLeads } from './DefaultLeads';
import { EditableStrip } from './EditableStrip';
import { GainPickerContainer } from './GainPickerContainer';
import { GridContainer } from './GridContainer';
import { ManualNoiseBar } from './ManualNoiseBar';
import { NoiseWaves } from './NoiseWaves';
import { PlotHeader } from './PlotHeader';
import { STRIP_EDITOR_WIDTH, StripEditor } from './StripEditor';
import { StripPosition } from './StripPosition';
import { WaveNoiseOptionalTags } from './WaveNoiseOptionalTags';
import { Plot } from '../contexts/plot.context';
import { Row } from '../contexts/row.context';
import { Strip } from '../contexts/strip.context';
import {
  SINGLE_LEAD,
  squareToPixel,
  TOP_PLOT_FOOTER_HEIGHT,
} from '../utils/graph.utils';
import { Ruler2d } from '../../ruler2d/components/Ruler2d';
import { Ruler2dContainer } from '../../ruler2d/components/Ruler2dContainer';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';

export const SINGLE_LEAD_STRIP_ID = `${SINGLE_LEAD}-strip`;
const SINGLE_PLOT_HEIGHT = squareToPixel(24);
const SPACER_HEIGHT = TOP_PLOT_FOOTER_HEIGHT / 3;

export const SingleLeadPlot = () => {
  const isRuler2DActive = useSelector(isToolActiveSelector(Tool.ruler2d));
  const leads = useSelector(leadNamesSelector);

  return (
    <Strip id={SINGLE_LEAD_STRIP_ID} leads={[leads[0]]} duration={10000}>
      <Plot>
        <PlotHeader offset={STRIP_EDITOR_WIDTH} height={60}>
          <WaveNoiseOptionalTags />
        </PlotHeader>
      </Plot>
      <Plot
        cursor={isRuler2DActive ? 'crosshair' : undefined}
        plotName='lead'
        data-testid='lead-plot'
      >
        <Row height={SINGLE_PLOT_HEIGHT}>
          <StripEditor>
            <GainPickerContainer />
          </StripEditor>
          <EditableStrip>
            <GridContainer />
            <StripPosition>
              <DefaultLeads />
              <NoiseWaves />
              <Ruler2dContainer>
                <Ruler2d />
              </Ruler2dContainer>
              <ManualNoiseBar />
            </StripPosition>
          </EditableStrip>
        </Row>
      </Plot>
      <Plot>
        <Row height={SPACER_HEIGHT} />
        <AxisContainer offset={STRIP_EDITOR_WIDTH} />
      </Plot>
    </Strip>
  );
};
